export default {
  // Common
  common: {
    loading: 'Ładowanie...',
    loadingData: 'Ładowanie danych...',
    save: 'Zapisz',
    cancel: 'Anuluj',
    delete: 'Usuń',
    edit: 'Edytuj',
    close: 'Zamknij',
    confirm: 'Potwierdź',
    back: 'Powrót',
    next: 'Dalej',
    previous: 'Poprzedni',
    search: 'Szukaj',
    filter: 'Filtruj',
    clearFilters: 'Wyczyść filtry',
    clear: 'Wyczyść',
    all: 'Wszystkie',
    none: 'Brak',
    yes: 'Tak',
    no: 'Nie',
    actions: 'Akcje',
    details: 'Szczegóły',
    download: 'Pobierz',
    downloadPDF: 'Pobierz PDF',
    viewDetails: 'Zobacz szczegóły',
    noData: 'Brak danych',
    error: 'Błąd',
    success: 'Sukces',
    warning: 'Ostrzeżenie',
    info: 'Informacja',
    date: 'Data'
  },

  // DataTable common
  dataTable: {
    sortBy: 'Sortuj według',
    sortAsc: 'Rosnąco',
    sortDesc: 'Malejąco',
    filters: 'Filtry',
    applyFilters: 'Zastosuj filtry',
    clearFilters: 'Wyczyść filtry'
  },

  // Navigation
  nav: {
    home: 'Start',
    invoices: 'Faktury',
    issues: 'Zgłoszenia',
    generation: 'Wytwarzanie',
    data: 'Dane',
    customers: 'Klienci',
    contracts: 'Umowy',
    consumptionPoints: 'Punkty poboru',
    myAccount: 'Moje konto',
    profile: 'Profil',
    linkAccount: 'Połącz konto',
    logout: 'Wyloguj',
    backToSite: 'Powrót',
    operatorManagement: 'Zarządzanie operatorami',
    impersonate: 'Impersonacja',
    menu: 'Menu',
    openMenu: 'Otwórz menu',
    closeMenu: 'Zamknij menu',
    help: 'Instrukcja obsługi'
  },

  // Footer
  footer: {
    help: 'Instrukcja obsługi',
    terms: 'Regulamin EPK',
    privacy: 'Polityka prywatności',
    support: 'Problem z portalem',
    supportSubject: 'Portal EPK — problem techniczny',
    securedBy: 'Bezpieczne płatności obsługuje',
    autopayAlt: 'Autopay'
  },

  // Help / User manual
  help: {
    tocLabel: 'Spis treści',
    translationPending: 'Tłumaczenie tej sekcji jest w toku — wyświetlamy wersję polską.',
    sectionNotFound: 'Sekcja nie istnieje.',
    backToHome: 'Powrót do pulpitu',
    backToFirstSection: 'Wróć do pierwszej sekcji',
    loadFailed: 'Nie udało się załadować instrukcji.'
  },

  // Auth
  auth: {
    login: 'Zaloguj się',
    logout: 'Wyloguj',
    register: {
      subtitle: 'Zarejestruj się, aby uzyskać dostęp do portalu energetycznego.',
      firstNamePlaceholder: 'Jan',
      lastNamePlaceholder: 'Kowalski',
      phonePlaceholder: '+48 000 000 000',
      phoneHint: '+48 jest wpisany domyślnie — możesz go zmienić, jeśli numer jest spoza Polski. Format: +<kod kraju><cyfry>',
      phoneFormatError: 'Numer musi zaczynać się od „+" i kodu kraju (np. +48 dla Polski).',
      passwordMinLength: 'Minimum 8 znaków',
      passwordMinLengthError: 'Hasło musi mieć co najmniej 8 znaków',
      passwordMismatch: 'Hasła nie są zgodne',
      submitButton: 'Zarejestruj się',
      submitting: 'Tworzenie konta...',
      failed: 'Rejestracja nie powiodła się. Spróbuj ponownie.',
      alreadyHaveAccount: 'Masz już konto? Zaloguj się'
    },
    email: 'Email',
    password: 'Hasło',
    confirmPassword: 'Potwierdź hasło',
    firstName: 'Imię',
    lastName: 'Nazwisko',
    phone: 'Telefon',
    forgotPassword: 'Zapomniałeś hasła?',
    noAccount: 'Nie masz konta? Zarejestruj się tutaj',
    hasAccount: 'Masz już konto? Zaloguj się',
    loggingIn: 'Logowanie...',
    registering: 'Rejestracja...',
    loginFailed: 'Logowanie nie powiodło się. Spróbuj ponownie.',
    registerSuccess: 'Rejestracja zakończona sukcesem. Sprawdź email w celu weryfikacji.',
    welcomeBack: 'Witamy ponownie! Zaloguj się do swojego konta.',
    createAccount: 'Utwórz swoje konto w Elektronicznym Portalu Klienta',
    passwordReset: 'Resetowanie hasła',
    passwordResetRequest: 'Poproś o reset hasła',
    passwordResetConfirm: 'Potwierdź nowe hasło',
    resetPassword: 'Zresetuj hasło',
    enterEmail: 'Podaj swój adres email',
    enterNewPassword: 'Podaj nowe hasło',
    passwordResetSent: 'Link do resetowania hasła został wysłany na Twój email.',
    passwordResetSuccess: 'Hasło zostało zmienione. Możesz się teraz zalogować.',
    invalidResetToken: 'Nieprawidłowy lub wygasły token resetowania hasła.',
    tooManyAttempts: 'Zbyt wiele prób logowania. Spróbuj ponownie za {minutes} min.',
    verifyEmail: {
      title: 'Weryfikacja adresu email',
      verifying: 'Weryfikacja w toku...',
      success: 'Twój adres email został pomyślnie zweryfikowany.',
      alreadyVerified: 'Ten adres email został już wcześniej zweryfikowany.',
      error: 'Nieprawidłowy lub wygasły token weryfikacyjny.',
      noToken: 'Brak tokenu weryfikacyjnego w linku.',
      goToLogin: 'Przejdź do logowania'
    },
    resendVerification: {
      description: 'Podaj adres email, na który chcesz ponownie wysłać link aktywacyjny.',
      submit: 'Wyślij',
      success: 'Link aktywacyjny został wysłany na podany adres email.'
    },
    emailNotVerified: 'Adres email nie został zweryfikowany. Sprawdź swoją skrzynkę pocztową.',
    resendButton: 'Wyślij ponownie link aktywacyjny',
    alreadyVerified: 'Adres email został już zweryfikowany. Jeśli nie pamiętasz hasła, użyj opcji resetowania hasła.',
    resetPasswordLink: 'Zresetuj hasło'
  },

  // Dashboard
  dashboard: {
    welcome: 'Witaj, {name}!',
    welcomeDefault: 'Witaj, Użytkowniku!',
    subtitle: 'Oto przegląd Twojego konta energetycznego',
    currentBalance: 'Saldo bieżące',
    activeContracts: 'Aktywne umowy',
    expiringContracts: '{count} wygasających wkrótce',
    allContractsCurrent: 'Wszystkie aktualne',
    monthlyConsumption: 'Zużycie w bieżącym miesiącu',
    consumptionChange: '{percent}% {direction} niż w zeszłym miesiącu',
    consumptionMore: 'więcej',
    consumptionLess: 'mniej',
    noConsumptionData: 'Brak danych z poprzedniego miesiąca',
    consumptionBreakdownTitle: 'Zużycie w bieżącym miesiącu wg PPE',
    breakdownPpeCode: 'Kod PPE',
    breakdownCustomer: 'Klient',
    breakdownConsumption: 'Zużycie',
    breakdownChange: '% m/m',
    openInvoices: 'Otwarte faktury',
    overdueInvoices: '{count} przeterminowanych',
    noOverdueInvoices: 'Brak przeterminowanych',
    balanceOutsideSelfService: 'Część salda dotyczy dokumentów niedostępnych w portalu — skontaktuj się z nami',
    newIssue: 'Nowa sprawa',
    linkCustomerAccount: 'Połącz konto klienta',
    reportIssue: 'Zgłoś sprawę',
    recentInvoices: 'Ostatnie faktury',
    recentContracts: 'Ostatnie umowy',
    recentIssues: 'Ostatnio aktywne zgłoszenia',
    activeTasks: 'Aktywne sprawy',
    viewAll: 'Zobacz wszystkie',
    noActiveIssues: 'Brak aktywnych zgłoszeń',
    allMattersResolved: 'Wszystkie sprawy zostały załatwione',
    loadFailed: 'Nie udało się załadować danych dashboard'
  },

  // Invoices
  invoices: {
    title: 'Faktury',
    subtitle: 'Przeglądaj i zarządzaj swoimi fakturami',
    invoiceNumber: 'Numer faktury',
    customer: 'Klient',
    issueDate: 'Data wystawienia',
    amount: 'Kwota',
    overpaymentTooltip: 'Kwota nadpłaty',
    paymentDeadline: 'Termin płatności',
    status: 'Status',
    period: 'Okres',
    consumption: 'Zużycie',
    dateRange: 'Zakres dat',
    searchPlaceholder: 'Numer faktury...',
    allCustomers: 'Wszyscy klienci',
    customerOptionNip: '{name} (NIP {nip})',
    customerOptionNumber: '{name} (nr klienta {number})',
    allStatuses: 'Wszystkie',
    noInvoices: 'Brak faktur',
    loadFailed: 'Nie udało się załadować faktur',
    downloadSuccess: 'Faktura została pobrana',
    downloadFailed: 'Nie udało się pobrać faktury PDF',
    showingResults: 'Pokazuje {first} do {last} z {total} faktur',
    statuses: {
      paid: 'Opłacona',
      pending: 'Oczekująca',
      unpaid: 'Nieopłacona',
      overdue: 'Przeterminowana',
      partiallyPaid: 'Częściowo opłacona',
      cancelled: 'Anulowana'
    },
    paymentMethod: {
      transfer: 'Przelew',
      compensation: 'Kompensata',
      payment: 'Płatność'
    },
    lineItems: {
      title: 'Pozycje',
      description: 'Opis',
      quantity: 'Ilość',
      unitPrice: 'Cena jedn.',
      value: 'Wartość',
      empty: 'Brak pozycji'
    },
    detail: {
      loadFailed: 'Nie udało się załadować szczegółów faktury',
      title: 'Szczegóły faktury',
      issuedOn: 'Wystawiono: {date}',
      billingPeriod: 'Okres rozliczeniowy',
      paymentHistory: 'Historia płatności',
      summary: 'Podsumowanie',
      netAmount: 'Wartość netto',
      vat: 'VAT ({rate}%)',
      totalDue: 'Razem do zapłaty',
      paidAmount: 'Zapłacono',
      remainingAmount: 'Pozostało do zapłaty',
      settledAmount: 'Rozliczono',
      outstandingAmount: 'Pozostało do rozliczenia',
      taxId: 'NIP',
      contract: 'Umowa'
    }
  },

  // Contracts
  contracts: {
    title: 'Umowy',
    subtitle: 'Przeglądaj i zarządzaj swoimi umowami energetycznymi',
    contractNumber: 'Numer umowy',
    customer: 'Klient',
    dateFrom: 'Data od',
    dateTo: 'Data do',
    status: 'Status',
    searchPlaceholder: 'Numer umowy...',
    allCustomers: 'Wszyscy klienci',
    allStatuses: 'Wszystkie',
    noContracts: 'Brak umów',
    loadFailed: 'Nie udało się załadować umów',
    daysUntilExpiration: '{days} dni do wygaśnięcia',
    statuses: {
      active: 'Aktywna',
      expiring: 'Wygasająca',
      expired: 'Wygasła',
      pending: 'Oczekująca',
      cancelled: 'Anulowana'
    },
    detail: {
      consumptionPoints: 'Punkty poboru energii',
      address: 'Adres',
      tariffGroup: 'Grupa taryfowa',
      contractedPower: 'Moc umowna'
    }
  },

  // Issues
  issues: {
    schedule: {
      before: 'Harmonogram — przed poprawką',
      after: 'Harmonogram — po poprawce',
      beforeDate: 'Data błędnej modyfikacji',
      afterDate: 'Data poprawnej modyfikacji',
      selectPpeAndDate: 'Wybierz PPE oraz datę, aby wczytać harmonogram.',
    },
    title: 'Moje zgłoszenia',
    subtitle: 'Historia i status Twoich spraw',
    newIssue: 'Nowe zgłoszenie',
    createFirst: 'Utwórz pierwsze zgłoszenie',
    noIssues: 'Brak zgłoszeń',
    noIssuesDescription: 'Nie masz jeszcze żadnych zgłoszeń',
    searchPlaceholder: 'Szukaj w zgłoszeniach...',
    allStatuses: 'Wszystkie',
    allCustomers: 'Wszyscy klienci',
    daysUntilDeadline: '{days} dni do terminu',
    addReply: 'Dodaj odpowiedź',
    replyPlaceholder: 'Napisz odpowiedź...',
    loadFailed: 'Nie udało się załadować zgłoszeń',
    reopenedToast: 'Odpowiedź dodana. Zgłoszenie zostało otwarte ponownie.',
    commentAddedToast: 'Komentarz został dodany',
    commentFailedToast: 'Nie udało się dodać komentarza',
    finishedBanner: {
      title: 'Zgłoszenie zostało zakończone',
      deadlineHint: 'Możesz dodać komentarz jeszcze przez {deadline}. Po tym czasie zgłoszenie zostanie zamknięte na stałe.',
      reopenHint: 'Dodanie komentarza spowoduje ponowne otwarcie zgłoszenia.'
    },
    canceledBanner: {
      title: 'Zgłoszenie zostało anulowane przez Ciebie',
      deadlineHint: 'Możesz dodać komentarz jeszcze przez {deadline}. Po tym czasie zgłoszenie zostanie zamknięte na stałe.',
      reopenHint: 'Dodanie komentarza spowoduje ponowne otwarcie zgłoszenia.'
    },
    cancel: {
      button: 'Anuluj zgłoszenie',
      dialogTitle: 'Anulowanie zgłoszenia',
      dialogQuestion: 'Czy na pewno chcesz anulować to zgłoszenie?',
      dialogHint: 'Po anulowaniu będziesz mógł dodawać komentarze jeszcze przez 3 dni. Możesz też utworzyć nowe zgłoszenie w dowolnym momencie.',
      dialogCancel: 'Nie, wróć',
      dialogConfirm: 'Tak, anuluj zgłoszenie',
      toastSuccess: 'Zgłoszenie zostało anulowane',
      toastError: 'Nie udało się anulować zgłoszenia'
    },
    statuses: {
      new: 'Nowe',
      inProgress: 'W trakcie',
      reopened: 'Otworzone ponownie',
      waiting: 'Oczekiwanie na klienta',
      waitingThirdParty: 'Oczekiwanie na odpowiedź dystrybucji',
      completed: 'Ukończone',
      canceled: 'Anulowane',
      archived: 'Zarchiwizowane',
      deferred: 'Odłożone'
    },
    fields: {
      document_number: 'Numer dokumentu',
      ppe_number: 'Numer PPE',
      new_reading_cycle: 'Nowy cykl odczytowy',
      target_tariff: 'Docelowa taryfa',
      reported_to_osd: 'Czy zmiana została już zgłoszona do OSD?',
      report_to_osd: 'Czy zgłosić zmianę do OSD w imieniu Klienta?',
      effective_date_type: 'Data obowiązywania zmiany',
      first_available_date: 'Pierwszy możliwy termin',
      other_date: 'Inna data',
      current_power: 'Obecna moc umowna',
      target_power: 'Docelowa moc umowna',
      connection_power_change: 'Czy moc przyłączeniowa ulega zmianie?',
      connection_power_warning: 'Zmiana mocy przyłączeniowej może zostać dokonana przez Klienta bezpośrednio w OSD.',
      block_connection_power_change: 'Zmiana mocy przyłączeniowej może zostać dokonana przez Klienta bezpośrednio w OSD.',
      is_new_connection: 'Czy nowy PPE jest nowym przyłączem?',
      osd: 'Jakie jest OSD?',
      current_seller: 'Kto jest obecnym sprzedawcą?',
      termination_period: 'Jaki jest okres wypowiedzenia?',
      assignee_data: 'Dane Cesjonariusza',
      assignment_start_date: 'Data rozpoczęcia cesji',
      contract_number: 'Numer umowy',
      extension_period: 'Okres przedłużenia',
      installation_power: 'Moc instalacji',
      energy_type: 'Rodzaj energii',
      energy_type_full: 'W całości',
      energy_type_surplus: 'Nadwyżka',
      ppe_numbers: 'Numery PPE',
      period_start: 'Okres od',
      period_end: 'Okres do',
      new_contact: 'Nowy numer telefonu / adres mailowy',
      keep_old_contact: 'Czy poprzedni kontakt pozostawić?',
      invoice_numbers: 'Numery faktur',
      meter_reading: 'Stan licznika',
      not_nots_number: 'Numer NOT/NOTS',
      summons_number: 'Numer wezwania',
      summons_date: 'Data wezwania',
      compensation_number: 'Numer kompensaty / oświadczenia',
      penalty_number: 'Numer kary umownej',
      additional_info: 'Opis',
      opis_zgloszenia: 'Opis zgłoszenia',
      searchPlaceholder: 'Szukaj...',
      yes: 'Tak',
      no: 'Nie',
      assignee_name: 'Nazwa Cesjonariusza',
      assignee_nip: 'NIP Cesjonariusza',
      assignee_address: 'Adres podstawowy',
      assignee_correspondence_address: 'Adres korespondencyjny',
      assignee_contact: 'Dane kontaktowe',
      bank_name: 'Nazwa banku',
      bank_account: 'Numer konta bankowego',
      annual_surplus_volume_mwh: 'Prognozowany roczny wolumen nadwyżki',
      keep_previous_contact: 'Czy poprzedni numer telefonu/adres mailowy pozostawić do kontaktu?',
      selectAll: 'Wszystkie',
      loadingOptions: 'Ładowanie opcji...',
      requiredField: 'To pole jest wymagane',
      osdAutoFillPlaceholder: 'OSD zostanie ustawione po wyborze PPE',
      osdAutoFillLoading: 'Odczytuję OSD z PPE...',
      osdAutoFillErrorSummary: 'Błąd OSD',
      osdAutoFillError: 'Nie udało się odczytać OSD — skontaktuj się z obsługą.',
      osdAutoFillPpeNotFound: 'Nie znaleziono PPE o podanym numerze. Sprawdź wpisany kod.',
      osdAutoFillMissing: 'Uzupełnij numer PPE, aby system wypełnił pole OSD. Bez OSD nie można wysłać zgłoszenia.',
      osdAutoFillFailedPlaceholder: 'Wybierz OSD ręcznie'
    },
    info: {
      overpayment_scan: 'Prosimy o załączenie wniosku o zwrot nadpłaty w formie skanu.',
      correction_note_scan: 'Prosimy o załączenie noty korygującej w formie skanu.',
      termination_signature: 'Prosimy o załączenie wypowiedzenia umowy: elektronicznie z podpisem kwalifikowanym lub w formie oryginału do siedziby firmy — w przeciwnym razie wypowiedzenie będzie nieważne.',
      assignment_osd_process: 'Po zgłoszeniu zmiany właściciela do OSD rozpoczyna się proces weryfikacji (21 dni–1,5 miesiąca). Operator wyznaczy datę, od której faktury będą wystawiane na nowego odbiorcę.',
      new_connection_docs: 'Prosimy o załączenie aktu własności oraz dokumentów wymaganych przez OSD.',
      existing_connection_docs: 'Prosimy o załączenie najnowszych faktur dystrybucyjnych oraz co najmniej jednej faktury sprzedażowej.',
      required_attachments: 'Wymagane załączniki',
      property_right_document: 'Prosimy o przesłanie dokumentu potwierdzającego prawo do lokalu.',
      osd_reading_cycles: 'Dostępne cykle rozliczeniowe w zależności od OSD',
      wniosek_zwrot_nadplaty: 'Prosimy o załączenie wniosku o zwrot nadpłaty w formie skanu.',
      wniosek_cesja: 'Po zgłoszeniu zmiany właściciela do Operatora Systemu Dystrybucyjnego (OSD) rozpoczyna się proces weryfikacji, który trwa od około 21 dni do 1,5 miesiąca. Operator wyznaczy konkretną datę, od której zmiana odbiorcy zostanie formalnie wprowadzona. Dopiero od tego momentu faktury będą wystawiane na nowego odbiorcę.\n\nProsimy o przesłanie dokumentu potwierdzającego prawo do lokalu.',
      wypowiedzenie_umowy: 'Prosimy o załączenie wypowiedzenia umowy: elektronicznie z podpisem kwalifikowanym lub w formie oryginału do siedziby firmy — w przeciwnym razie wypowiedzenie będzie nieważne.',
      nota_korygujaca: 'Prosimy o załączenie noty korygującej w formie skanu.',
      wniosek_zmiana_cyklu_odczytowego: 'Dostępne cykle rozliczeniowe w zależności od OSD:\n• Energa: 1m, 2m, 6m, 12m\n• Tauron: 1m, 2m, 6m, 12m\n• Stoen: 1m, 6m, 12m\n• Enea: 1m, 2m, 6m, 12m\n• PGE: 1m, 2m, 6m',
      wniosek_dodanie_ppe_when_true: 'Prosimy o załączenie aktu własności oraz dokumentów wymaganych przez OSD.',
      wniosek_dodanie_ppe_when_false: 'Prosimy o załączenie najnowszych faktur dystrybucyjnych oraz co najmniej jednej faktury sprzedażowej.',
      wniosek_dodanie_ppe_osd_enea: 'Dla ENEA wymagane są: karta danych technicznych — warunki przyłączeniowe, umowa o przyłączenie.',
      wniosek_dodanie_ppe_osd_energa: 'Dla ENERGA wymagane jest: oświadczenie o wykonaniu przyłącza.',
      wniosek_dodanie_ppe_osd_pge: 'Dla PGE wymagane jest: potwierdzenie możliwości świadczenia usług dystrybucji i określenie parametrów technicznych.',
      wniosek_dodanie_ppe_osd_tauron: 'Dla TAURON wymagane są: zaświadczenie o wykonaniu przyłącza, karta danych technicznych, zgłoszenie gotowości instalacji do przyłączenia.',
      wniosek_dodanie_ppe_osd_innogy: 'Dla INNOGY wymagane są: dane techniczne wykonanego przyłącza, gotowość instalacji do przyłączenia, umowa przyłączeniowa.',
      wniosek_dodanie_ppe_osd_stoen: 'Dla STOEN wymagane są: dane techniczne wykonanego przyłącza, gotowość instalacji do przyłączenia, umowa przyłączeniowa.'
    },
    errors: {
      formDataInvalidSummary: 'Błąd formularza',
      formDataInvalid: 'Nieprawidłowy format danych formularza — odśwież stronę i spróbuj ponownie'
    }
  },

  // New Issue
  newIssue: {
    title: 'Nowe zgłoszenie',
    subtitle: 'Zgłoś sprawę do obsługi klienta',
    back: 'Powrót',
    customer: 'Klient',
    customerPlaceholder: 'Wybierz klienta',
    category: 'Kategoria',
    categoryPlaceholder: 'Wybierz kategorię',
    subcategory: 'Podkategoria',
    subcategoryPlaceholder: 'Wybierz podkategorię',
    selectCategoryFirst: 'Najpierw wybierz kategorię',
    issueTitle: 'Tytuł zgłoszenia',
    titlePlaceholder: 'Krótki opis problemu...',
    description: 'Opis',
    descriptionPlaceholder: 'Szczegółowy opis problemu, okoliczności, oczekiwania...',
    descriptionHint: 'Podaj jak najwięcej szczegółów, aby przyspieszyć rozwiązanie sprawy.',
    submit: 'Wyślij zgłoszenie',
    cancel: 'Anuluj',
    submitting: 'Wysyłanie...',
    submitSuccess: 'Zgłoszenie zostało utworzone pomyślnie. Za chwilę nastąpi przekierowanie...',
    submitFailed: 'Nie udało się utworzyć zgłoszenia. Spróbuj ponownie.',
    attachments: 'Załączniki',
    addMoreFiles: 'Dodaj więcej plików',
    formFields: 'Dane formularza',
    validation: {
      customerRequired: 'Wybierz klienta',
      categoryRequired: 'Prośba o wybór kategorii zgłoszenia',
      subcategoryRequired: 'Prośba o wybór podkategorii zgłoszenia',
      titleRequired: 'Podaj tytuł zgłoszenia',
      titleMinLength: 'Tytuł musi mieć co najmniej 5 znaków',
      descriptionRequired: 'Podaj opis zgłoszenia',
      descriptionMinLength: 'Opis musi mieć co najmniej 20 znaków',
      dynamicFieldRequired: 'Pole "{field}" jest wymagane',
      numericRequired: 'Proszę wprowadzić liczbę',
      minValue: 'Wartość nie może być mniejsza niż {min}'
    },
    help: {
      title: 'Jak zgłosić sprawę?',
      step1: '1. Wybierz klienta - jeśli masz dostęp do kilku kont, wybierz którego dotyczy zgłoszenie.',
      step2: '2. Prosimy o wybranie odpowiedniej kategorii oraz podkategorii zgłoszenia, aby łatwiej zidentyfikować problem i przyspieszyć jego rozwiązanie.',
      step3: '3. Opisz szczegółowo - podaj wszystkie istotne informacje: numery dokumentów, daty, okoliczności.',
      footer: 'Po wysłaniu zgłoszenia otrzymasz potwierdzenie, a nasz zespół zajmie się sprawą w ciągu 14 dni.'
    }
  },

  // Meter Reading
  meterReading: {
    title: 'Podaj stan licznika',
    submit: 'Wyślij odczyt'
  },

  // Navigation (additional)
  navigation: {
    newIssue: 'Zgłoś sprawę',
    meterReading: 'Podaj stan licznika'
  },

  // Customers
  customers: {
    title: 'Klienci',
    subtitle: 'Zarządzaj połączonymi kontami klientów',
    customerName: 'Klient',
    customerNumber: 'Numer klienta',
    nipPesel: 'NIP/PESEL',
    linkedAt: 'Data powiązania',
    searchPlaceholder: 'Szukaj klienta...',
    searchHint: 'Nazwa, numer klienta lub NIP',
    ppeSearchPlaceholder: 'Szukaj punktu...',
    ppeSearchHint: 'Kod PPE, adres lub taryfa',
    noCustomers: 'Brak połączonych kont klientów'
  },

  // Consumption Points
  consumptionPoints: {
    title: 'Punkty poboru i wytwarzania energii',
    subtitle: 'Zarządzaj punktami poboru i wytwarzania energii',
    ppeCode: 'Kod PPE',
    noCode: 'Brak kodu',
    customer: 'Klient',
    category: 'Kategoria',
    tariff: 'Taryfa',
    contract: 'Umowa',
    contractActive: 'Aktywna',
    contractInactive: 'Nieaktywna',
    searchPlaceholder: 'Szukaj punktu...',
    searchHint: 'Kod PPE, adres, taryfa lub klient',
    allCategories: 'Wszystkie',
    allCustomers: 'Wszyscy klienci',
    noConsumptionPoints: 'Brak punktów poboru i wytwarzania',
    loadFailed: 'Nie udało się załadować punktów poboru',
    invoicesEmpty: 'Brak faktur dla tego punktu',
    categories: {
      consumption: 'Pobór',
      generation: 'Oddanie'
    }
  },

  // Generation Scheduling
  scheduling: {
    contractedPower: 'Moc umowna',
    generationSource: 'Źródło wytwarzania',
    unitKw: 'kW',
    title: 'Harmonogramowanie wytwarzania',
    subtitle: 'Zarządzaj harmonogramami wytwarzania energii dla punktów wytwórczych',
    listTitle: 'Harmonogramowanie wytwarzania',
    listSubtitle: 'Zarządzaj harmonogramami wytwarzania energii dla punktów wytwórczych',
    detailTitle: 'Harmonogram wytwarzania',
    selectPoint: 'Wybierz punkt wytwarzania',
    pointPlaceholder: 'Wybierz punkt...',
    selectDate: 'Wybierz datę',
    scheduleDate: 'Data harmonogramu',
    schedule: 'Harmonogram',
    schedule24h: 'Harmonogram 24-godzinny',
    hour: 'Godzina',
    valueKwh: 'Wartość (kWh)',
    systemProposed: 'Systemowa (kWh)',
    effectiveValue: 'Wynikowa (kWh)',
    source: 'Źródło',
    sourceSystem: 'System',
    sourceUser: 'Użytkownik',
    sourceSystemUser: 'System+Użytkownik',
    total: 'Suma',
    totalEdited: 'Suma edytowanych',
    totalSystem: 'Suma systemowych',
    totalEffective: 'Suma wynikowa',
    userHours: 'Godzin użytkownika',
    editedNow: 'Zmienione',
    deadline: 'Termin',
    deadlinePassed: 'Termin minął',
    deadlineInfo: 'Termin zgłoszenia: {time}',
    deadlineNotice: 'Termin na złożenie harmonogramu: {time}',
    saveSchedule: 'Zapisz',
    downloadExcel: 'Pobierz',
    uploadFromFile: 'Wczytaj z pliku',
    restoreSystem: 'Przywróć systemowe',
    noPoints: 'Brak punktów wytwórczych',
    loadFailed: 'Nie udało się załadować harmonogramu',
    saveSuccess: 'Harmonogram został zapisany pomyślnie',
    saveFailed: 'Nie udało się zapisać harmonogramu',
    deadlinePassedError: 'Termin na złożenie harmonogramu minął',
    noChanges: 'Brak zmian do zapisania',
    hoursModified: '{count} godzin',
    // List page
    generationPoint: 'Punkt wytwórczy',
    noPpeCode: 'Brak kodu PPE',
    customer: 'Klient',
    allCustomers: 'Wszyscy klienci',
    systemTotal: 'Suma systemowa',
    effectiveTotal: 'Suma wynikowa',
    editSchedule: 'Edytuj/pokaż harmonogram',
    refresh: 'Odśwież',
    showingPoints: 'Pokazano {first} do {last} z {totalRecords} punktów',
    // Source/status labels
    sources: {
      none: 'Brak danych',
      system: 'System',
      partial: 'System+Użytkownik',
      full: 'Użytkownik'
    },
    // Upload dialog
    uploadDialog: {
      title: 'Wczytaj harmonogram z pliku Excel',
      description: 'Możesz pobrać szablon i go zmodyfikować lub pobrać aktualny harmonogram, zmodyfikować go i zaimportować tutaj.',
      downloadTemplate: 'pobrać szablon',
      warning: 'Jeśli plik zawiera datę lub kod PPE, muszą one zgadzać się z aktualnie wybranym harmonogramem.',
      selectFile: 'Wybierz plik Excel',
      upload: 'Wczytaj',
      uploadSuccess: 'Wczytano {count} wartości godzinowych. Kliknij "Zapisz" aby zapisać zmiany.',
      uploadFailed: 'Nie udało się odczytać pliku Excel. Sprawdź czy plik jest w poprawnym formacie.',
      noData: 'Nie znaleziono danych godzinowych w pliku',
      dateMismatch: 'Data w pliku ({fileDate}) nie zgadza się z wybraną datą ({selectedDate})',
      ppeMismatch: 'Kod PPE w pliku ({filePpe}) nie zgadza się z aktualnym ({currentPpe})',
      invalidStatuses: 'Pominięto nieznane lub niedozwolone statusy dla godzin: {hours}',
      invalidStatusReasons: {
        notAllowedAfterDeadline: 'niedozwolony po terminie'
      }
    },
    // Status column
    status: 'Status',
    statusOptions: {
      none: 'Brak',
      other: 'Inne',
      pseRedispatch: 'Redysponowanie PSE',
      installationFailure: 'Awaria instalacji',
      powerReduction: 'Redukcja mocy',
      plannedMaintenance: 'Planowany remont',
      plannedShutdown: 'Planowane wyłączenie'
    },
    setStatusForAll: 'Ustaw status dla wszystkich godzin',
    bulkStatusDescription: 'Wybrany status zostanie zastosowany do wszystkich 24 godzin w harmonogramie.',
    selectStatus: 'Wybierz status',
    apply: 'Zastosuj',
    // Deadline indicator
    deadlineIndicator: {
      canEdit: 'Możesz edytować harmonogram do',
      cannotEdit: 'Termin edycji minął',
      statusOnly: 'Po terminie możesz zmienić status tylko dla wczorajszego dnia (Redysponowanie PSE, Awaria instalacji). Dla starszych dat edycja jest zablokowana.'
    },
    // Other
    modified: 'Zmodyfikowano',
    lastChange: 'Ostatnia zmiana',
    back: 'Powrót',
    systemApplied: 'Wartości systemowe zostały zastosowane do wszystkich godzin',
    templateDownloaded: 'Szablon został pobrany',
    templateDownloadFailed: 'Nie udało się pobrać szablonu',
    excelDownloaded: 'Plik Excel został pobrany',
    excelDownloadFailed: 'Nie udało się pobrać pliku Excel',
    editingUnavailable: 'Edycja harmonogramu jest niedostępna',
    uploadUnavailable: 'Wczytywanie harmonogramu jest niedostępne - termin minął',
    tolerance: {
      exceeded: 'Wartość przekracza limit tolerancji ({max} kWh)',
      importWarning: '{count} wartości przekracza limit tolerancji ({max} kWh/h)'
    }
  },

  // Account Matching
  accountMatching: {
    title: 'Połącz konto',
    subtitle: 'Połącz swoje konto klienta, aby uzyskać dostęp do faktur, umów i punktów poboru energii',
    verification: 'Weryfikacja konta',
    modeNip: 'Weryfikacja przez NIP',
    modeNipDescription: 'Dla firm i klientów posiadających NIP',
    modePesel: 'Weryfikacja przez PESEL',
    modePeselDescription: 'Dla klientów indywidualnych bez NIP',
    nip: 'NIP',
    nipPlaceholder: '0000000000',
    nipHint: '10-cyfrowy numer identyfikacji podatkowej',
    pesel: 'PESEL',
    peselPlaceholder: '00000000000',
    peselHint: '11-cyfrowy numer PESEL z umowy',
    peselFormatError: 'Numer PESEL musi składać się z 11 cyfr i mieć poprawną sumę kontrolną.',
    identifierNone: '—',
    phone: 'Numer telefonu',
    phonePlaceholder: '+48 000 000 000',
    phoneHint: '+48 jest wpisany domyślnie — możesz go zmienić, jeśli numer jest spoza Polski. Format: +<kod kraju><cyfry>',
    phoneFormatError: 'Numer musi zaczynać się od „+" i kodu kraju (np. +48 dla Polski).',
    customerNumber: 'Numer klienta',
    customerNumberPlaceholder: '123456',
    customerNumberHint: 'Numer z umowy lub faktury',
    submit: 'Połącz konto',
    submitting: 'Weryfikacja...',
    success: 'Konto zostało pomyślnie połączone!',
    failed: 'Nie udało się połączyć konta. Sprawdź wprowadzone dane.',
    notFound: 'Nie znaleziono konta z podanymi danymi.',
    alreadyLinked: 'To konto jest już połączone z Twoim profilem.',
    rateLimited: 'Zbyt wiele prób. Spróbuj ponownie później.',
    attemptsRemaining: 'Pozostało prób: {count}',
    noAttemptsLeft: 'Wykorzystałeś limit prób. Spróbuj ponownie za {minutes} min. Podane dane muszą być zgodne z umową — sprawdź też, czy wybrałeś właściwy tryb weryfikacji (NIP czy PESEL). Więcej informacji znajdziesz w instrukcji:',
    noAttemptsLeftUnknown: 'To była Twoja ostatnia próba — kolejna zostanie zablokowana. Podane dane muszą być zgodne z umową — sprawdź też, czy wybrałeś właściwy tryb weryfikacji (NIP czy PESEL). Więcej informacji znajdziesz w instrukcji:',
    instructions: 'Aby połączyć konto, podaj dane weryfikacyjne z faktury lub umowy.',
    linkedAccounts: 'Połączone konta',
    accountsCount: '{count} konto | {count} kont',
    noLinkedAccounts: 'Nie masz jeszcze połączonych kont',
    useFormAbove: 'Użyj formularza powyżej, aby połączyć swoje konto klienta',
    active: 'Aktywne',
    linked: 'Połączono',
    detach: 'Odłącz',
    detachConfirm: 'Czy na pewno chcesz odłączyć to konto?',
    detachFailed: 'Nie udało się odłączyć konta.'
  },

  // Profile
  profile: {
    title: 'Profil użytkownika',
    subtitle: 'Portal klienta',
    personalInfo: 'Dane konta',
    email: 'Adres email',
    userId: 'ID użytkownika',
    linkedCustomers: 'Powiązani klienci',
    firstName: 'Imię',
    lastName: 'Nazwisko',
    phone: 'Telefon',
    changePassword: 'Zmień hasło',
    currentPassword: 'Aktualne hasło',
    newPassword: 'Nowe hasło',
    confirmNewPassword: 'Potwierdź nowe hasło',
    saveChanges: 'Zapisz zmiany',
    updateSuccess: 'Profil został zaktualizowany',
    updateFailed: 'Nie udało się zaktualizować profilu',
    passwordChangeSuccess: 'Hasło zostało zmienione',
    passwordChangeFailed: 'Nie udało się zmienić hasła',
    editComingSoon: 'Funkcje edycji profilu będą dostępne wkrótce.',
    deleteAccount: 'Usuń konto',
    deleteAccountTitle: 'Usuwanie konta',
    deleteAccountWarning: 'Ta operacja jest nieodwracalna. Wszystkie Twoje dane osobowe zostaną trwale usunięte, a dostęp do konta zostanie zablokowany.',
    confirmDeletion: 'Potwierdź usunięcie',
    deleteAccountSuccess: 'Konto zostało usunięte.',
    deleteAccountError: 'Nie udało się usunąć konta. Sprawdź hasło i spróbuj ponownie.',
    enterPasswordToConfirm: 'Podaj aktualne hasło, aby potwierdzić',
    linkedAccountsWarning: 'Twoje powiązania z {count} kontami klientów zostaną dezaktywowane.',
    accountDeletedBanner: 'Konto zostało pomyślnie usunięte i zanonimizowane.',
    adminCannotDelete: 'Konta administratorów nie mogą być usunięte samodzielnie. Skontaktuj się z pomocą techniczną.',
    tooManyAttempts: 'Zbyt wiele prób. Spróbuj ponownie później.'
  },

  // Operator Management
  operatorManagement: {
    title: 'Zarządzanie operatorami',
    subtitle: 'Przydzielaj i odbieraj dostęp operatorski do obiektów wytwórczych',
    assign: {
      title: 'Przydziel operatora',
      description: 'Przydziel użytkownikowi dostęp operatorski do wybranego obiektu wytwórczego.',
      userEmail: 'Email użytkownika',
      userEmailPlaceholder: "operator{'@'}przykład.pl",
      customerNumber: 'Numer klienta',
      customerNumberPlaceholder: 'np. 12345',
      ppeCode: 'Kod PPE',
      ppeCodePlaceholder: 'np. PPE-001W',
      ppeCodeHint: 'Kod punktu poboru zakończony literą W (obiekt wytwórczy)',
      ppeSelectCustomerFirst: 'Najpierw wybierz klienta',
      submit: 'Przydziel operatora',
      success: 'Użytkownik został przydzielony jako operator.',
      failed: 'Nie udało się przydzielić operatora.',
      errorUserNotFound: 'Możesz dodawać tylko zarejestrowanych użytkowników.',
      errorInvalidRole: 'Użytkownik nie może zostać przydzielony jako operator.',
      fullAccessConfirmHeader: 'Potwierdź przydzielenie Full Access',
      fullAccessConfirmMessage: 'Ten użytkownik ma rolę Full Access. Zostanie mu przyznany pełny dostęp do tego klienta. Czy chcesz kontynuować?'
    },
    operators: {
      title: 'Lista operatorów',
      filterPlaceholder: 'Szukaj operatora, klienta, PPE...',
      operator: 'Operator',
      customer: 'Klient',
      ppe: 'Obiekt (PPE)',
      role: 'Rola',
      roleOperator: 'Operator',
      roleFullAccess: 'Pełny dostęp',
      noOperators: 'Brak przydzielonych operatorów',
      loadFailed: 'Nie udało się załadować listy operatorów',
      removeTooltip: 'Odbierz dostęp',
      removeHeader: 'Potwierdź odebranie dostępu',
      removeConfirm: 'Czy na pewno chcesz odebrać dostęp operatorski dla {email} do klienta {customer}?',
      removeAccept: 'Odbierz dostęp',
      removeFailed: 'Nie udało się odebrać dostępu operatorskiego.',
      showingResults: 'Pokazano {first} do {last} z {totalRecords} operatorów'
    },
    observe: {
      title: 'Przydziel obserwatora',
      description: 'Przydziel użytkownikowi dostęp obserwatora do wybranego PPE. Ten sam użytkownik nie może być przydzielony do tego samego PPE dwa razy.',
      userEmail: 'Email użytkownika',
      userEmailPlaceholder: "obserwator{'@'}przykład.pl",
      customerNumber: 'Numer klienta',
      customerNumberPlaceholder: 'np. 12345',
      ppeCode: 'Kod PPE',
      ppeCodePlaceholder: 'np. PPE-001',
      ppeCodeHint: 'Dowolny punkt poboru lub wytwarzania (nie tylko z W)',
      ppeSelectCustomerFirst: 'Najpierw wybierz klienta',
      submit: 'Przydziel obserwatora',
      success: 'Użytkownik został przydzielony jako obserwator.',
      failed: 'Nie udało się przydzielić obserwatora.'
    },
    observers: {
      title: 'Lista obserwatorów',
      filterPlaceholder: 'Szukaj obserwatora, klienta, PPE...',
      observer: 'Obserwator',
      customer: 'Klient',
      ppe: 'PPE',
      noObservers: 'Brak przydzielonych obserwatorów',
      loadFailed: 'Nie udało się załadować listy obserwatorów',
      removeTooltip: 'Odbierz dostęp obserwatora',
      removeHeader: 'Potwierdź odebranie dostępu',
      removeConfirm: 'Czy na pewno chcesz odebrać dostęp obserwatora dla {email} do PPE {ppe}?',
      removeAccept: 'Odbierz dostęp',
      removeFailed: 'Nie udało się odebrać dostępu obserwatora.',
      showingResults: 'Pokazano {first} do {last} z {totalRecords} obserwatorów'
    }
  },

  // Impersonation
  impersonate: {
    startError: 'Nie udało się rozpocząć impersonacji — przywrócono sesję',
    banner: {
      acting_as: 'Działasz jako {email}',
      stop: 'Zakończ impersonację'
    },
    panel: {
      title: 'Impersonacja użytkownika',
      search: 'Szukaj użytkownika (email, nazwa)...',
      email: 'Email',
      role: 'Rola',
      customers: 'Powiązani klienci',
      action: 'Impersonuj',
      confirm_title: 'Potwierdzenie impersonacji',
      confirm_message: 'Czy na pewno chcesz działać jako {email}?'
    },
    error: {
      forbidden: 'Brak uprawnień do impersonacji',
      admin_target: 'Nie można impersonować administratora'
    }
  },

  // Deletion warning
  deletion_warning: {
    banner: {
      message: 'Twoje konto zostanie usunięte {date} z powodu: {reason}. Zaloguj się regularnie aby zapobiec usunięciu.'
    },
    reasons: {
      expired_contract: 'wygaśnięcia umowy',
      unverified_account: 'nieaktywowanego konta'
    }
  },

  // Errors
  errors: {
    general: 'Wystąpił błąd',
    networkError: 'Błąd połączenia z serwerem',
    unauthorized: 'Sesja wygasła. Zaloguj się ponownie.',
    forbidden: 'Brak dostępu do tego zasobu',
    notFound: 'Zasób nie został znaleziony',
    serverError: 'Błąd serwera. Spróbuj ponownie później.'
  },

  // 404 Page
  notFound: {
    title: 'Strona nie znaleziona',
    message: 'Przepraszamy, strona której szukasz nie istnieje.',
    backHome: 'Wróć na stronę główną'
  },

  // Payment
  payment: {
    success: {
      title: 'Płatność przyjęta',
      message: 'Dziękujemy za opłacenie należności.',
      sync_info: 'Status faktury zaktualizuje się w ciągu kilku minut.',
    },
    processing: {
      title: 'Płatność w trakcie realizacji',
      message: 'Otrzymaliśmy Twoje zlecenie płatności. Faktura zostanie oznaczona jako opłacona po potwierdzeniu przez bank — zwykle w ciągu kilku minut.',
    },
    error: {
      title: 'Wystąpił problem',
      message: 'Nie udało się przetworzyć płatności. Spróbuj ponownie lub skontaktuj się z BOK.',
      contact: 'Skontaktuj się z BOK: {email}',
      contact_with_phone: 'Skontaktuj się z BOK: {email}, tel. {phone}',
      invoice_already_paid: 'Faktura już została opłacona.',
      customer_email_missing: 'Brak adresu email klienta. Skontaktuj się z BOK.',
      access_denied: 'Brak dostępu do tej faktury.',
      gateway_unavailable: 'Bramka płatności niedostępna. Spróbuj za kilka minut.',
      rate_limit_exceeded: 'Zbyt wiele prób. Spróbuj ponownie za kilka minut.',
      invoice_unpaid: 'Faktura pozostaje nieopłacona.',
    },
    neutral: {
      title: 'Status płatności',
      message: 'Nie można potwierdzić statusu płatności. Sprawdź swoje faktury w portalu.',
    },
    invoice: 'Faktura',
    back_to_invoice: 'Wróć do faktury',
    view_invoices: 'Przejdź do faktur',
    login: 'Zaloguj się',
    loading: 'Sprawdzanie statusu płatności...',
    pay_amount: 'Zapłać {amount}',
    redirecting: 'Przekierowanie do bramki płatności...',
    invoice_paid: 'Faktura opłacona',
    pay_page: {
      title: 'Płatność za fakturę',
      invoice: 'Faktura',
      amount_due: 'Do zapłaty',
      due_date: 'Termin płatności',
      customer: 'Klient',
      validity_info: 'Po kliknięciu "Zapłać" zostaniesz przekierowany do bramki płatności. Masz 24 godziny na ukończenie płatności.',
      already_paid: 'Faktura została opłacona.',
      token_expired: 'Link wygasł. Skontaktuj się z BOK ({email}) aby otrzymać nowy link.',
      token_expired_with_phone: 'Link wygasł. Skontaktuj się z BOK pod {phone} lub {email} aby otrzymać nowy link.',
      invalid_token: 'Nieprawidłowy link płatności. Skontaktuj się z BOK ({email}).',
      invalid_token_with_phone: 'Nieprawidłowy link płatności. Skontaktuj się z BOK pod {phone} lub {email}.',
      missing_token: 'Nieprawidłowy link płatności. Skontaktuj się z BOK ({email}).',
      missing_token_with_phone: 'Nieprawidłowy link płatności. Skontaktuj się z BOK pod {phone} lub {email}.',
      invoice_not_found: 'Faktura nie została znaleziona.',
      gateway_error: 'Bramka płatności chwilowo niedostępna. Spróbuj za kilka minut.',
      invoice_already_paid: 'Faktura już została opłacona.',
      rate_limit_exceeded: 'Zbyt wiele prób. Spróbuj ponownie za kilka minut.',
      payment_in_progress: 'Płatność jest w realizacji. Faktura zostanie oznaczona jako opłacona po potwierdzeniu przez bank.',
      connection_error: 'Brak połączenia z serwerem. Sprawdź połączenie z internetem i spróbuj ponownie.',
    },
  }
}
